import React from 'react'

export function ProjectsIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4 21V4c4-1.5 6-1 9 .5 2.086 1.043 5.5 0 7-1v9.906c-1.5 1.094-4.914 2.043-7 1-3-1.5-5-2-9-.5'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  )
}
